import * as yup from 'yup'
import { DEFAULT_REQUIRED_MESSAGE } from 'src/utils'

yup.setLocale({
  mixed: {
    required: DEFAULT_REQUIRED_MESSAGE
  }
})

export const validationSchema = yup.object().shape({
  code: yup.string().trim().required(),
  newPassword: yup.string().trim().required(),
  confirmNewPassword: yup.string().trim().required().test(
    'senha-iguais',
    'As senhas não conferem',
    function (value) {
      return value === this.parent.newPassword
    }
  )
})
